export const colors = {
  grey: {
    50: '#f6f3f3',
    100: '#ede8e8',
    200: '#d9d3d3',
    300: '#bab5b5',
    400: '#9b9797',
    500: '#7a7a7a',
    600: '#5a5c5e',
    700: '#45474a',
    800: '#2f3337',
    900: '#1b1f22',
  },
  blue: {
    50: '#edf8fc',
    100: '#dcf2f9',
    200: '#b9e5f4',
    300: '#84d1eb',
    400: '#50bee2',
    500: '#22a6d3',
    600: '#1a7d9e',
    700: '#14617b',
    800: '#0e4558',
    900: '#092a35',
  },
  green: {
    50: '#f3fbef',
    100: '#e7f6df',
    200: '#cfedbf',
    300: '#aae090',
    400: '#86d260',
    500: '#64bf36',
    600: '#4b8f28',
    700: '#3a6f1f',
    800: '#295016',
    900: '#19300d',
  },
  orange: {
    50: '#fff5eb',
    100: '#feebd7',
    200: '#fdd6af',
    300: '#fcb873',
    400: '#fb9937',
    500: '#f27c05',
    600: '#b45c04',
    700: '#8c4703',
    800: '#643302',
    900: '#3c1f01',
  },
  red: {
    50: '#feefec',
    100: '#fde0d9',
    200: '#fac1b2',
    300: '#f69279',
    400: '#f3633f',
    500: '#e63a0f',
    600: '#ad2b0b',
    700: '#862209',
    800: '#601806',
    900: '#3a0e04',
  },
  backgroundDark: '#141719',
  white: '#FFFFFF',
  black: '#000000',
  purple: '#CB2CAB',
  violet: '#7C19DE',
} as const;
